import React, { useState, useEffect } from 'react';

const DarkModeToggle = () => {
  // Initialize state from localStorage or default to dark mode
  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storedTheme = window.localStorage.getItem('theme');
      // If no theme is stored, default to dark mode
      if (storedTheme === null) {
        return true;
      }
      return storedTheme === 'dark';
    }
    return true; // Default to dark mode when localStorage is not available
  });

  // Update the HTML root class and localStorage when mode changes
  useEffect(() => {
    const root = window.document.documentElement;
    if (isDarkMode) {
      root.classList.add('dark');
      window.localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      window.localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  // Toggle handler
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className="scale-[1.2] opacity-80">
      <label className="cursor-pointer">
        <input
          className="toggle-checkbox sr-only"
          type="checkbox"
          checked={isDarkMode}
          onChange={toggleDarkMode}
        />
        <div className="toggle-slot">
          <div className="sun-icon-wrapper"> 
            <div className="flex items-center gap-1">
              <span className="text-label text-xs">Light</span>
              <svg 
                className="sun-icon w-3 h-3" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
            </div>
          </div>
          <div className="toggle-button"></div>
          <div className="moon-icon-wrapper">
            <div className="flex items-center gap-1">
              <span className="text-label text-xs">Dark</span>
              <svg 
                className="moon-icon w-3 h-3" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"></path>
              </svg>
            </div>
          </div>
        </div>
      </label>

      <style jsx>{`
        .toggle-slot {
          position: relative;
          height: 2rem;
          width:7.5rem;
        //   border: 2px solid #e2e8f0;
          border-radius: 2rem;
          background-color: #cbd5e0;
        //   box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
          transition: background-color 0.25s cubic-bezier(0.27, 0.01, 0.38, 1.06), border-color 0.25s cubic-bezier(0.27, 0.01, 0.38, 1.06);
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.5rem 0.75rem;
        }

        .sun-icon-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 2rem;
          width: 2.5rem;
          opacity: 1;
          color: ;
          z-index: 10;
        }

        .moon-icon-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 2rem;
          width: 2.5rem;
          opacity: 0.4;
          color: #64748b;
          z-index: 10;
        }

        .text-label {
          font-size: 0.6rem;
          font-weight: 500;
          color: inherit;
          white-space: nowrap;
        }

        .toggle-button {
          position: absolute;
          left: 0.125rem;
          height: 1.5rem;
          width: 3.5rem;
          border-radius: 999px;
          background-color: #ffffff;
          box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.1);
          transition: all 0.25s cubic-bezier(0.27, 0.01, 0.38, 1.06);
          transform: translateX(.15rem);
          z-index: 5;
        }

        .toggle-checkbox:checked + .toggle-slot {
          background-color: #333;
        }

        .toggle-checkbox:checked + .toggle-slot .sun-icon-wrapper {
          opacity: 0.4;
          color: #64748b;
        }

        .toggle-checkbox:checked + .toggle-slot .moon-icon-wrapper {
          opacity: 1;
          color: #fff;
        }

        .toggle-checkbox:checked + .toggle-slot .toggle-button {
          background-color: #555555;
          transform: translateX(3.6rem);
        }

        .toggle-slot:hover {
          box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 2px 12px 0 rgba(0, 0, 0, 0.15);
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </div>
  );
};

export default DarkModeToggle;